export const DEVIATION_ANALYSIS_LABELS = {
    marketValue: 'Marktwert',
    mortgageLendingValue: 'Beleihungswert',
    landValue: 'Bodenwert',
    incomeMarketValue: 'Ertragswert',
    costMarketValue: 'Sachwert',
    comparisonMarketValue: 'Vergleichswert',
    transactionCosts: 'Transaktionskosten',
    grossCapitalValue: 'Bruttokapitalwert',
    ancillaryAcquisitionCosts: 'Erwerbsnebenkosten',
    netCapitalValue: 'Nettokapitalwert',
    totalSpecialPropertyFeatures: 'BOG',

    // currently has dynamic custom label, this here is as default
    perAreaValue: 'Wert pro m²',

    grossRentalIncome: 'Rohertrag (Marktmiete)',
    contractualRentalIncome: 'Jahresmiete (Vertragsmiete)',
    managementCosts: 'Bewirtschaftungskosten',
    maintenanceCost: 'Instandhaltungskosten',
    administrativeCost: 'Verwaltungskosten',
    operatingCost: 'Nicht umlagefähige Betriebskosten',
    lossOfRentRiskCost: 'Mietausfallwagnis',
    netRentalIncome: 'Reinertrag',
    netIncomeConstruction: 'Reinertrag der baulichen Anlage',
    valueConstruction: 'Ertragswert der baulichen Anlage',

    grossYieldMultiplier: 'Rohertragsmultiplikator',
    netYieldMultiplier: 'Reinertragsmultiplikator',
    grossYield: 'Yield (Bruttorendite)',
    netYield: 'Nettorendite',
    grossInitialYield: 'Bruttoanfangsrendite',
    discountRate: 'Liegenschaftszinssatz',

    grossFloorArea: 'Bruttogrundfläche',
    rentableArea: 'Vermietbare Fläche',

    marketValueResults: 'Marktwertergebnisse',
    keyEarningsFigures: 'Ertragskennzahlen',
    costs: 'Kosten',
    yieldFigures: 'Rendite',
    valuationRelevantAreas: 'Flächen',
    valuationStructureLifeSpans: 'Restnutzungsdauer',
} as const

export const DEVIATION_ANALYSIS_SECTION_KEYS = [
    'marketValueResults',
    'keyEarningsFigures',
    'costs',
    'yieldFigures',
    'valuationRelevantAreas',
    'valuationStructureLifeSpans',
] as const

export type DeviationAnalysisLabelKey = keyof typeof DEVIATION_ANALYSIS_LABELS
export type DeviationAnalysisSectionLabelKey = (typeof DEVIATION_ANALYSIS_SECTION_KEYS)[number]
export type DeviationAnalysisRowLabelKey = Exclude<DeviationAnalysisLabelKey, DeviationAnalysisSectionLabelKey>
